import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import Avatar from '@pushpay/avatar';
import { clsx } from '@pushpay/styles';
import { useLink } from '../link-provider';
import { useCloseProfileDropdown } from './profile-context';
import { useStyles } from './profile-panel-style';
export const ProfilePanel = ({
  classes: classesProp,
  'data-pp-at-target': targetId,
  emailAddress,
  firstName,
  lastName,
  profileId,
  profileImgUrl,
  profileLabel,
  profileLink,
  profilePath,
  deprecated = true
}) => {
  const classes = useStyles(classesProp, {
    deprecated
  });
  const {
    Link
  } = useLink();
  const close = useCloseProfileDropdown();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.profileSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.avatarWrap
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: classes.profileSectionAvatar,
    id: profileId,
    name: [firstName, lastName],
    imgUrl: profileImgUrl,
    "data-pp-at-target": `${targetId}-profile-section-avatar`
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.profileInfoWrap
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx(classes.profileInfoOverflowHidden, classes.fullNameText)
  }, firstName, " ", lastName), /*#__PURE__*/React.createElement("span", {
    className: clsx(classes.profileInfoOverflowHidden, classes.emailText)
  }, emailAddress), profileLink && /*#__PURE__*/React.createElement(Link, {
    href: profileLink,
    className: classes.profileLink,
    title: profileLabel,
    "data-pp-at-target": `${targetId}-profile-link`
  }, profileLabel), profilePath && /*#__PURE__*/React.createElement(ReactRouterLink, {
    to: profilePath,
    onClick: close,
    title: profileLabel,
    className: classes.profileLink,
    "data-pp-at-target": `${targetId}-profile-path`
  }, profileLabel)));
};